import {useEffect, useState} from 'react';
import type {RingTargetState} from '@phonehq/rtc-core';
import {groupCallService} from '../../groupCalls/services/groupCallService';
import logger from '../../../services/logger';
import {inviteesOf} from './invitees';

const POLL_MS = 3_000;

export const useInvitees = (roomId: string | undefined, inCall: ReadonlySet<string>, active: boolean, since?: number): readonly RingTargetState[] => {
    const [targets, setTargets] = useState<readonly RingTargetState[]>([]);
    useEffect(() => {
        if (!roomId || !active) {
            return;
        }
        let cancelled = false;
        const load = () => {
            groupCallService.ringTargets(roomId)
                .then(next => {
                    if (!cancelled) {
                        setTargets(next);
                    }
                })
                .catch(error => logger.debug('Group call invitees unavailable', {
                    source: 'group_call',
                    event: 'invitees_failed',
                    error: error instanceof Error ? error.message : String(error),
                }));
        };
        load();
        const timer = window.setInterval(load, POLL_MS);
        return () => {
            cancelled = true;
            window.clearInterval(timer);
        };
    }, [active, roomId]);
    return inviteesOf(targets, inCall, since);
};
